import * as React from "react"

interface IProps{
  cost:number;
  revenue:number;
}

function ProfitBar(props: IProps){
  const revenue_percent = ( ((props.revenue - props.cost) / props.revenue) * 100 )
  const cost_percent = 100 - revenue_percent

  return (
    <div className="progress">
      <div className="progress-bar progress-bar-danger" style={{width:`${cost_percent}%`}}>
      </div>      
      <div className="progress-bar progress-bar-success" style={{width:`${revenue_percent}%`}}>
      </div>
    </div>
  )
}

export default ProfitBar


// WEBPACK FOOTER //
// ./app/javascript/components/core/ProfitBar.tsx